<template>
    <div class="apprentice-simple-card user-credentials-edit">
        <h3 class="title">{{ $t('user_account.personal_info') }}</h3>
        <div class="description">{{ $t('user_account.edit_personal_info') }}</div>

        <div class="credentials">
            <div class="row">
                <div class="col-12">
                    <div
                        class="notification-setting"
                        v-if="userType !== 'organization' && this.$authUser.isTeacher()">
                        <div class="notification-name">
                            <b-form-checkbox
                                class="initial_only"
                                v-model="initial_only"
                                name="checkbox-3"
                                :value="1"
                                :unchecked-value="0"
                                @change="storeSettings"
                                switch>
                            </b-form-checkbox>
                            <span class="label">{{ $t('user_account.use_initials') }}</span>
                        </div>
                        <div class="short-description">
                            {{ $t('user_account.use_initials_and_surname_description') }}
                        </div>
                    </div>
                </div>
                <div class="col-12 col-md-4 offset-md-0 col-xl-3">
                    <design-2021-user-avatar-upload-component
                        :user-in="userIn"></design-2021-user-avatar-upload-component>
                </div>
                <div class="col-12 col-md-7 offset-md-1 col-xl-8">
                    <div class="bio">
                        <b-form-group
                            id="input-group-1"
                            :label="$t('common.first_name')"
                            label-for="input-1">
                            <div v-show="nameError">
                                <b-alert
                                    show
                                    variant="danger"
                                    >{{ $t('user_account.first_name_mandatory') }}
                                </b-alert>
                            </div>

                            <b-form-input
                                id="input-1"
                                v-model="form.name"
                                type="text"
                                :disabled="this.$authUser.isStudent()"></b-form-input>
                        </b-form-group>

                        <b-form-group
                            id="input-group-2"
                            :label="$t('common.infix')"
                            label-for="input-2">
                            <b-form-input
                                id="input-2"
                                v-model="form.preposition"
                                type="text"
                                :disabled="this.$authUser.isStudent()"></b-form-input>
                        </b-form-group>

                        <b-form-group
                            id="input-group-3"
                            :label="$t('common.last_name')"
                            label-for="input-3">
                            <div v-show="surnameError">
                                <b-alert
                                    show
                                    variant="danger"
                                    >{{ $t('validation.last_name_mandatory') }}
                                </b-alert>
                            </div>
                            <b-form-input
                                id="input-3"
                                v-model="form.surname"
                                type="text"
                                :disabled="this.$authUser.isStudent()"></b-form-input>
                        </b-form-group>

                        <b-form-group
                            id="input-group-4"
                            :label="`${$t('common.email')}:`"
                            label-for="input-4">
                            <div v-show="emailError">
                                <b-alert
                                    show
                                    variant="danger"
                                    >{{ $t('user_account.email_mandatory') }}
                                </b-alert>
                            </div>

                            <b-form-input
                                id="input-4"
                                v-model="form.email"
                                type="email"></b-form-input>
                        </b-form-group>

                        <b-form-group
                            id="input-group-5"
                            v-if="userIn.type === 'teacher'"
                            label="Vakken"
                            label-for="courses">
                            <design-2021-apprentice-multiselect-component
                                id="teacher-account-courses"
                                v-model="selectedCourses"
                                :multiple-select="true"
                                :options="coursesIn"
                                :placeholder="'Selecteer vakken'"
                                label="name"
                                :selected-in="courses"></design-2021-apprentice-multiselect-component>
                        </b-form-group>

                        <b-form-group
                            id="magister-number-group"
                            v-if="userIn.type === 'student' && userIn.las_location_provider === 'magister'"
                            label="magister-nummer"
                            label-for="magister-number-input">
                            <b-form-input
                                id="magister-number-input"
                                v-model="form.magister_number"
                                type="text"></b-form-input>
                        </b-form-group>

                        <b-button
                            type="button"
                            variant="primary"
                            @click="onSubmit"
                            >{{ $t('common.save') }}
                        </b-button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'design-2021-user-account-data-component',
    props: ['userIn', 'coursesIn', 'userType'],
    data() {
        return {
            user: this.userIn,
            surnameError: false,
            nameError: false,
            emailError: false,
            form: {
                name: this.userIn.name,
                preposition: this.userIn.preposition,
                surname: this.userIn.surname,
                email: this.userIn.email,
                selected_course_ids: [],
                magister_number: this.userIn.magister_number,
            },
            selectedCourses: [],
            courses: this.userIn.courses,
            initial_only: this.userIn.initial_only,
        };
    },
    methods: {
        onSubmit() {
            this.nameError = this.form.name === '';
            this.surnameError = this.form.surname === '';
            this.emailError = this.form.email === '';

            if (this.form.surname !== '' && this.form.name !== '' && this.form.email !== '') {
                if (this.selectedCourses.length > 0) {
                    for (const course of this.selectedCourses) {
                        this.form.selected_course_ids.push(course.id);
                    }
                } else {
                    this.form.selected_course_ids = [];
                }

                this.alert.saving();

                this.axios.post(this.routes.accountUpdate(), this.form).then(
                    (response) => {
                        this.alert.success();
                        window.location.reload();
                    },
                    (error) => {
                        if (
                            error.response.data.errors &&
                            error.response.data.errors.email &&
                            error.response.data.errors.email.length &&
                            error.response.data.errors.email[0] === 'email is al in gebruik.'
                        ) {
                            this.alert.ajaxError(
                                error,
                                this.$t('common.email'),
                                this.$t('accounts.email_address_could_not_be_saved'),
                                false,
                            );
                        } else {
                            this.alert.ajaxError(error);
                        }
                    },
                );
            }
        },

        storeSettings() {
            let data = {
                darkmode: 1,
                status_mail: this.userIn.mail_settings ? this.userIn.mail_settings.status_mail : 1,
                notifications: this.userIn.mail_settings ? this.userIn.mail_settings.notifications : 1,
                initial_only: this.initial_only,
            };

            this.alert.saving();

            this.axios.post(this.routes.userSettings(), data).then(
                (response) => {
                    this.alert.success();
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },
    },
};
</script>

<style scoped lang="scss">
.title {
    margin-bottom: map-get($grid-gutter-spacing, 'ten');
}

.description {
    margin-bottom: $grid-gutter-width;
    color: $text-muted-color;
    font-weight: $font-weight-medium;
    font-size: $base-font-size;
}

.credentials {
    margin-top: map-get($grid-gutter-spacing, 'forty-two');
}

.notification-setting {
    margin-bottom: map-get($grid-gutter-spacing, 'forty-two');

    .notification-name {
        display: flex;
        flex-direction: row;
        column-gap: map-get($grid-gutter-spacing, 'five');
        align-items: center;

        .label {
            font-weight: $font-weight-bold;
            font-size: $base-font-size;
            margin-bottom: 0;
        }
    }
}

.short-description {
    color: $text-muted-color;
    font-weight: $font-weight-medium;
    margin-left: 41px;
}
</style>
